import { CSSProperties } from "react";

export default class DialogMultilineTextInputViewStyle {

    textField : CSSProperties = {
        //marginTop: 10
    }

    input : CSSProperties = {
        fontSize : 15,
        color : '#405364'
    };
}